
/* injects from baggage-loader */

/*global swal*/
'use strict';
import _ from 'lodash';

/**
 * Function that defines whether or not to enter the web page.
 *
 * @param {any} $transitions
 * @param {any} $auth
 * @param {any} $rootScope
 * @param {any} sessionFactory
 * @param {any} utilitiesConstant
 */
function runBlock($transitions, $auth, $rootScope, utilitiesFactory, sessionFactory, navigationConstant, userAccessConstant, utilitiesConstant) {
	'ngInject';

	/**
	 * valid before loading the web page if the user has permission to see it.
	 */
	$transitions.onBefore({}, transition => {
		const isAuthenticated = sessionFactory.get(utilitiesConstant.STORAGE.AUTHENTICATED) && $auth.isAuthenticated();
		/**
		 * Configuration data of the web page.
		 */
		const page = transition.to();
		/**
		 * If page is 404 = code 04, not validate nothing.
		 */
		if (page.data && page.data.code === '04') {
			return;
		}
		/**
	   * If page is / = authenticationDefault.
	   */
		if (page.url === '/') {
			return transition.router.stateService.target('authentication');
		}
		/**
		 * If page is 404 = code 04, not validate nothing.
		 */
		if (page.data && page.data.login && !isAuthenticated) {
			/**
			 * redirect to the 'authentication' state.
			 */
			return transition.router.stateService.target('authentication');
		}

		if (page.data && page.data.login && isAuthenticated) {
			const user = angular.fromJson(sessionFactory.get(utilitiesConstant.STORAGE.USER));

			if (user.salesmancode !== $rootScope.userAuth.salesmancode) {
				$rootScope.userAuth = user;
			}

			const accessList = page.data.submenu ? userAccessConstant[user.profile.codeEnum].SUBMENUS : userAccessConstant[user.profile.codeEnum].MENUS;
			if (_.includes(accessList, page.data.code)) {
				return;
			} else {
				return transition.router.stateService.target('notFound');
			}
		}

		if ((!page.data || !page.data.login) && isAuthenticated) {
			const profile = angular.fromJson(sessionFactory.get(utilitiesConstant.STORAGE.USER)).profile.codeEnum;

			/**
			 * redirect to the 'home' state assign to user profile.
			 */
			if (profile === utilitiesConstant.PROFILE.ADMIN) {
				return transition.router.stateService.target('campaign');
			} else if (profile === utilitiesConstant.PROFILE.CASHIER) {
				return transition.router.stateService.target('confirmed');
			} else if (profile === utilitiesConstant.PROFILE.COMPANY) {
				return transition.router.stateService.target('confirmed');
			} else {
				return transition.router.stateService.target('notFound');
			}
		}
	});

	/**
	 * valid after loading the web page successfully.
	 */
	$transitions.onSuccess({}, function (transition) {
		const page = transition.to();
		const pageTitle = utilitiesConstant.TITLE;
		$rootScope.pageTitle = page.data.pageTitle;
		$rootScope.title = pageTitle.concat(page.data ? page.data.pageTitle : '');

		utilitiesFactory.lockBackSpace();
		/**
		 * Close SweetAlert opened.
		 */
		if (swal) {
			swal.close();
		}
	});
}

export default runBlock;



// WEBPACK FOOTER //
// ./src/app/index.run.js